module.exports = __webpack_public_path__ + "media/assets/images/linkedin_icon-27cd6ff778a81a45fa461657e2b2858b.png";